module.exports = __webpack_public_path__ + "static/media/drop-grey.6f009954.svg";